//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'
import { getFilterIcon } from './ServerFilterIcons.js'
import ServerFilterPrependSlot from './ServerFilterPrependSlot.vue'
import ServerFilterListOptionSlot from './ServerFilterListOptionSlot.vue'

const LIMIT_OF_CHIPS = 10

export default {
  name: 'ServerFilterListTable',
  components: {
    ItemsSearchField: () => import('../../components/Field/ItemsSearchField.vue'),
    ServerFilterPrependSlot,
    ServerFilterListOptionSlot
  },
  props: {
    filter: {
      type: Object,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: null
    },
    nameValues: {
      type: String,
      default: 'Выбранные значения'
    },
    icon: {
      type: String,
      default: 'mdi-wrench'
    },
    displayKeysInTable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    }
  },
  data: function () {
    let cached = true
    if (this.filter.cached !== undefined) {
      cached = this.filter.cached
    } else if (this.filter.archiveOpts && this.filter.archiveOpts.length) {
      cached = false
    }

    return {
      LIMIT_OF_CHIPS: LIMIT_OF_CHIPS,
      fieldConfig: createFieldConfig(new Store({
        itemsFn: this.getOptions,
        fullReadable: true,
        cached: cached,
        searchable: true,
        searchFiltrationBySource: false,
        searchValueMinLength: 0
      })),
      cached: cached,
      getFilterIcon: getFilterIcon
    }
  },
  computed: {
    selectedValues: {
      get: function () {
        return this.filter.selectedValues
      },
      set: function (newValue) {
        if (newValue && newValue.length) {
          this.filter.selectedValues = newValue
        } else {
          this.filter.selectedValues = []
        }
      }
    }
  },
  watch: {
    filter: {
      handler: function (value) {
        this.fieldConfig = createFieldConfig(new Store({
          itemsFn: this.getOptions,
          fullReadable: true,
          cached: this.cached,
          searchable: true,
          searchFiltrationBySource: false,
          searchValueMinLength: 0
        }))
      }
    }
  },
  methods: {
    onInput: function (e) {
      this.$emit('input', e)
    },
    getNameById: function (id) {
      const value = this.filter.values.find(value => value.id === id)
      return value && value.name || null
    },
    getOptions: function () {
      if (this.filter.values && this.filter.values.length && !this.filter.url) {
        const options = this.filter.values.map((value) => {
          value.id = value.key
          return value
        })
        return this.formatArchiveOptions(options)
      } else if (this.filter.url) {
        const formData = new FormData()
        // formData.append('filterType', type)
        // if (formId != null) {
        //   formData.set('formId', formId)
        // }

        return axiosGet({
          url: this.filter.url,
          data: formData,
          onSuccess: (response) => this.formatArchiveOptions(response.data.result),
          onFailure: 'Ошибка загрузки данных для фильтра'
        })
      } else {
        return []
      }
    },
    formatArchiveOptions: function (options) {
      const formattedOptions = JSON.parse(JSON.stringify(options))
      formattedOptions.forEach((option, index) => {
        const changeRefPosition = (option) => {
          const indexOfRef = formattedOptions.findIndex(o => o.key === option.refToArchive)

          if (indexOfRef !== -1 && indexOfRef !== index) {
            const [refOption] = formattedOptions.splice(indexOfRef, 1)
            refOption.shift = (refOption.shift + 1) || 1

            // При удалении refOption индексы сдвигаются
            const targetIndex = indexOfRef > index ? index + 1 : index
            formattedOptions.splice(targetIndex, 0, refOption)

            if (refOption.refToArchive && refOption.refToArchive !== option.key) {
              changeRefPosition(refOption)
            }
          }
        }

        if (option.refToArchive) {
          changeRefPosition(option)
        }
      })

      formattedOptions.forEach(option => {
        if (option.isArchive) {
          let archiveText
          if (this.filter.key === 'packages') {
            archiveText = 'Архивный'
          } else {
            archiveText = 'Архивная'
          }
          option.name = `(${archiveText}) ` + option.name
        }
        if (option.shift > 0) {
          option.name = '—' + option.name
          for (let i = 0; i < option.shift; i++) {
            option.name = 'ㅤ' + option.name
          }
        }
      })
      return formattedOptions
    }
  }
}

